"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PadSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.PadSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('pad'),
    ref: zod_1.z.string(),
    name: zod_1.z.string(),
    pos: XYPosition_1.XYPositionSchema,
    diameter: zod_1.z.number().array(),
    angle: zod_1.z
        .number()
        .nullish()
        .transform((a) => a ?? 0),
    layers: zod_1.z.number().array().optional(),
    pin1: zod_1.z.coerce.boolean().optional(),
    shape: zod_1.z.enum(['rect', 'oval', 'circle', 'roundrect', 'custom']),
    polygons: XYPosition_1.XYPositionSchema.array().array().optional(),
    radius: zod_1.z.number().optional(),
    chamfpos: zod_1.z.number().optional(),
    chamfratio: zod_1.z.number().optional(),
    padType: zod_1.z.enum(['th', 'smd']),
    drillshape: zod_1.z.enum(['circle', 'oblong']).optional(),
    drillDiameter: zod_1.z.number().array().optional(),
    offset: XYPosition_1.XYPositionSchema.optional(),
});
//# sourceMappingURL=Pad.js.map